module.exports = __webpack_public_path__ + "static/media/drumset.60f752eb.mp3";